export default "__VITE_ASSET__BPmUOV8Z__"